import styled from "styled-components";

export const Form = styled.form``;

export const FormGroup = styled.div`
  display: flex;
  flex-flow: column-reverse;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

/**
 * Help text under a field, inside its FormGroup. The group stacks in reverse (label on top), so
 * `order: -1` keeps it at the bottom wherever it sits in the markup; the negative margin takes back
 * part of the field box's own 8px bottom margin so it reads as part of the field.
 * The Input takes it as its `hint`; next to a Select or TextArea, render it in the group.
 */
export const FieldHint = styled.p`
  order: -1;
  margin-top: -0.25rem;
  font-family: Inter, sans-serif;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-neutral-150);
`;
